<template>
  <nx-seo-site-editor
    :v-if="!disabled && value"
    v-validate="validation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-value-path="value"
    :value="value"
    v-bind="$attrs"
    @input="onInput">
  </nx-seo-site-editor>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxSeoSiteEditor from '@/modules/seo/editor/SiteEditor';

export default {
  name: 'nx-seo-form-site-editor',
  mixins: [FormElement],
  components: {
    NxSeoSiteEditor,
  },
  props: {
    value: {
      type: Object,
    },
  },
  methods: {
    onInput(value) {
      this.$parentForm.updateField(this.name, value);
    },
  },
};
</script>
